import { Client } from "./_clientService";

export async function getStoreBanners(options: any) {
  try {
    // let payload = {
    //   pageNo: options?.pageNo,
    //   limit: options?.pageSize,
    //   sortKey: "createdAt",
    //   sortDir: "ASC",
    //   search: options?.search,
    //   skipPagination: options?.skipPagination ?? false,
    // };
    let path = "/store-banner/list";
    const resp = await new Client({ path }).post();

    return resp;
  } catch (error) {
    throw error;
  }
}

export async function getStoreBannerInfo(storeBannerId: any) {
  try {
    const resp = await new Client({
      path: "/store-banner/info",
      payload: {
        storeBannerId: storeBannerId,
      },
    }).post();
    return resp;
  } catch (error) {
    throw error;
  }
}

export async function createStoreBanner(details: any) {
  try {
    const resp = await new Client({
      path: "/store-banner/create",
      payload: details,
    }).post();
    return resp;
  } catch (error) {
    throw error;
  }
}

export async function updateStoreBanner(details: any, storeBannerId: any) {
  try {
    const resp = await new Client({
      path: "/store-banner/update",
      payload: { ...details, _id: storeBannerId },
    }).post();
    return resp;
  } catch (error) {
    throw error;
  }
}

export async function deleteStoreBanner(storeBannerId: any) {
  const resp = await new Client({
    path: "store-banner/delete",
    payload: { storeBannerId },
  }).post();

  return resp;
}

export async function updateStoreBannerStatus(storeBannerId: any) {
  const resp = await new Client({
    path: "/store-banner/update/status",
    payload: { storeBannerId },
  }).patch();

  return resp;
}

export async function copyStoreBanner(storeBannerId: any) {
  const resp = await new Client({
    path: `/store-banner/copy`,
    payload: { input: { storeBannerId } },
  }).post();

  return resp;
}
